// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W3khOhKaBQE5LX80mrbe{height:100%;margin-top:9px;margin-right:-18px;overflow:hidden}.PZMNP5vWE7im1Ys2_vAO{padding-right:20px}.jgnn3ZsqJwYxn7vXQ3ij{max-height:100%}.tC1H0JYTt8eBAbuPdP_G{margin-top:40px;margin-bottom:10px;display:inline-flex}.KBagBc_S7IFGGCdAQxCO{margin-bottom:24px}.ebtubsvxtw5EL2_GTypV{border-top:1px solid var(--border-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `W3khOhKaBQE5LX80mrbe`,
	"scrollbar__content": `PZMNP5vWE7im1Ys2_vAO`,
	"scrollbarContent": `PZMNP5vWE7im1Ys2_vAO`,
	"scrollbar__view": `jgnn3ZsqJwYxn7vXQ3ij`,
	"scrollbarView": `jgnn3ZsqJwYxn7vXQ3ij`,
	"title": `tC1H0JYTt8eBAbuPdP_G`,
	"optInMethodTitle": `KBagBc_S7IFGGCdAQxCO`,
	"topBorder": `ebtubsvxtw5EL2_GTypV`
};
export default ___CSS_LOADER_EXPORT___;
